
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import PositionMarker from "../../editor/PositionMarker";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import MoverData from "../../../components/platformer/MoverData";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkHard3 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 5640, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 1039, 663);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -137, 805);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 345, 655);
    this.add(trunk_png);

    // trapSpikesMarker
    const trapSpikesMarker = new TrapMarkerSpikes(scene, 2149, -139);
    this.add(trapSpikesMarker);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage3(scene, -141, 503);
    this.add(platformMarkerFoliage);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 1036, 360);
    this.add(platformMarkerFoliage_1);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 3903, -304);
    this.add(gemMarker_11);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2302, -155);
    this.add(megaGemMarker_2);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 2164, -54);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 2697, -159);
    this.add(platformFoliage1);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 349, 350);
    this.add(platformFoliage2);

    // platformFoliage
    const platformFoliage = new PlatformFoliage1(scene, 1537, 94);
    this.add(platformFoliage);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 681, 591);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 1720, 841);
    this.add(trunk_png_5);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 2903, 711);
    this.add(trunk_png_6);

    // platformFoliage_4
    const platformFoliage_4 = new PlatformFoliage1(scene, 689, 286);
    this.add(platformFoliage_4);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1958, -163);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1724, 413);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1037, 257);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 1540, 13);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 351, 254);
    this.add(gemMarker_4);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 2390, 398);
    this.add(gemMarker_6);

    // trapSpikesMarker_1
    const trapSpikesMarker_1 = new TrapMarkerSpikes(scene, 695, 234);
    this.add(trapSpikesMarker_1);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4050, -292);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 5070, 290);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 5058, 592);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 5062, 197);
    this.add(gemMarker_7);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, 1727, 530);
    this.add(platformMarkerFoliage_6);

    // trapSpikesMarker_2
    const trapSpikesMarker_2 = new TrapMarkerSpikes(scene, 3759, -277);
    this.add(trapSpikesMarker_2);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage4(scene, 3914, -192);
    this.add(platformMarkerFoliage_7);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 4545, 787);
    this.add(trunk_png_9);

    // platformFoliage_1
    const platformFoliage_1 = new PlatformFoliage2(scene, 4549, 480);
    this.add(platformFoliage_1);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2698, -258);
    this.add(gemMarker_8);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 2226, 468);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 2565, 471);
    this.add(positionMarker_1);

    // platformFoliage_3
    const platformFoliage_3 = new PlatformFoliage1(scene, 4451, -72);
    this.add(platformFoliage_3);

    // platformMarkerJungleLog
    const platformMarkerJungleLog = new PlatformMarkerJungleLog(scene, 2231, 468);
    this.add(platformMarkerJungleLog);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 4559, 416);
    this.add(megaGemMarker_1);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 2482, 396);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 2299, 396);
    this.add(gemMarker_10);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 4459, -159);
    this.add(gemMarker_12);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -239, 463);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 1556, 458);
    this.add(checkpointMarker_1);

    // platformFoliage_6
    const platformFoliage_6 = new PlatformFoliage1(scene, 3561, 482);
    this.add(platformFoliage_6);

    // trunk_png_3
    const trunk_png_3 = new DecorationTrunk(scene, 3565, 787);
    this.add(trunk_png_3);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 3569, 384);
    this.add(gemMarker_14);

    // platformFoliage_7
    const platformFoliage_7 = new PlatformFoliage1(scene, 3321, 377);
    this.add(platformFoliage_7);

    // trunk_png_7
    const trunk_png_7 = new DecorationTrunk(scene, 3325, 682);
    this.add(trunk_png_7);

    // trapSpikesMarker_3
    const trapSpikesMarker_3 = new TrapMarkerSpikes(scene, 3335, 317);
    this.add(trapSpikesMarker_3);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage3(scene, 3171, -191);
    this.add(platformMarkerFoliage_2);

    // trapSpikesMarker_5
    const trapSpikesMarker_5 = new TrapMarkerSpikes(scene, 3073, -240);
    this.add(trapSpikesMarker_5);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 3236, -304);
    this.add(gemMarker_13);

    // trapSpikesMarker_4
    const trapSpikesMarker_4 = new TrapMarkerSpikes(scene, 1930, 461);
    this.add(trapSpikesMarker_4);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 2926, 304);
    this.add(gemMarker_15);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 3073, 316);
    this.add(megaGemMarker_3);

    // trapSpikesMarker_7
    const trapSpikesMarker_7 = new TrapMarkerSpikes(scene, 2782, 331);
    this.add(trapSpikesMarker_7);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 2937, 416);
    this.add(platformMarkerFoliage_3);

    // platformFoliage_2
    const platformFoliage_2 = new PlatformFoliage1(scene, 4039, 392);
    this.add(platformFoliage_2);

    // trunk_png_10
    const trunk_png_10 = new DecorationTrunk(scene, 4043, 697);
    this.add(trunk_png_10);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 4047, 294);
    this.add(gemMarker_5);

    // this (components)
    new ChunkBoundaries(this);

    // platformMarkerJungleLog (components)
    const platformMarkerJungleLogMoverData = new MoverData(platformMarkerJungleLog);
    platformMarkerJungleLogMoverData.startMarker = positionMarker;
    platformMarkerJungleLogMoverData.endMarker = positionMarker_1;
    platformMarkerJungleLogMoverData.startWait = 500;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
